import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'stringContains'
})
export class StringContainsPipe implements PipeTransform {

    transform(str: string, strForCheck: string): boolean {
       return _.includes(str.toLowerCase(), strForCheck.toLowerCase());
    }
}
